import styled from "@emotion/styled";
import { BaseCell } from "src/components/Table/Cells/shared";

export const PermissionCell = styled(BaseCell)`
  text-transform: capitalize;
`;
